import "core-js/modules/es.array.push.js";
import { Email } from "@faire/web/slate/icons/foundation/Email";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { ContactUsOptionsWrapper } from "./ContactUsOptionsWrapper";
import { IconWrapper } from "./IconWrapper";
export var EmailUs = function EmailUs(_ref) {
  var to = _ref.to,
    onClick = _ref.onClick;
  var history = useHistory();
  var handleClick = function handleClick() {
    onClick === null || onClick === void 0 ? void 0 : onClick();
    history.push(to);
  };
  return /*#__PURE__*/React.createElement(ContactUsOptionsWrapper, {
    onClick: handleClick,
    dataTestId: "email-us-btn"
  }, /*#__PURE__*/React.createElement(ColumnWrapper, null, /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(Email, {
    fontSize: "24"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "1/2x"
  }), /*#__PURE__*/React.createElement(LeftMarginWrapper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "IeOHlB",
    defaultMessage: "Email"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "fmpWBn",
    defaultMessage: "Average reply: 24 hours"
  })))));
};
export var ColumnWrapper = styled.div.withConfig({
  displayName: "EmailUs__ColumnWrapper"
})(["display:flex;flex-direction:column;min-width:200px;", "{flex-direction:row;min-width:250px;align-items:center;}"], responsiveMediaQueries.tabletAndBelow);
export var LeftMarginWrapper = styled(Column).attrs({
  justify: "center"
}).withConfig({
  displayName: "EmailUs__LeftMarginWrapper"
})(["margin-left:", ";", "{margin-left:", ";}"], getSpacing("1/2x"), responsiveMediaQueries.tabletAndBelow, getSpacing("2x"));